import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./completeRoutes.css";
import {
  getRoutesAPI,
  getRoutesAssignedAPI,
} from "../../../../services/rest/routes/routesServices";
import Loading from "../../../../components/Loading/Loading";
import MetricsOfRoutes from "./MetricsOfRoutes";
import { LuMapPinPlus } from "react-icons/lu";
import { IoReload } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import { Box, Button, Chip, Typography } from "@mui/material";
import TableRoutes from "../../../../components/Tables/TabbleRoutes";
import MapPreview from "./MapPreviewRoute";
import RouteIcon from "@mui/icons-material/Route";
import MilitaryTechIcon from "@mui/icons-material/MilitaryTech";
import { handleError } from "../../../../utils/handleError";
import toast from "react-hot-toast";
import {
  setlistRoutes,
  setListRoutesAssigned,
} from "../../../../redux/slice/routeSlice";
import ShareIcon from "@mui/icons-material/Share";
import ModalShareRoute from "./ModalSharedRoute";
import ModalNextToTheApp from "../../../../components/Dashboard/ModalNextToTheApp/ModalNextToTheApp";
import { filterRoutesOfMembership } from "../../../../utils/FilterRoutesOfMembership";
import { formatDistance } from "../../../../utils/formatDistance";

const CompleteRoutes = () => {
  const { listRoutesAssigned, listRoutesDontPublics, listRoutesPublicsOfUser } =
    useSelector((state) => state.routeReducer);
  const { membershipStatus, lastPayment, nextPayment } = useSelector(
    (state) => state.membershipReducer
  );
  const { status } = useSelector((state) => state.userReducer);
  const [loading, setLoading] = useState(false);
  const [routeSelected, setRouteSelected] = useState({});
  const [selectedChip, setSelectedChip] = useState("myRoutes");
  const [showModalShare, setShowModalShare] = useState(false);
  const [showModalNextApp, setShowModalNextApp] = useState(true);
  const navigation = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    refreshData();
  }, []);

  const refreshData = async () => {
    try {
      if (status !== "active" || membershipStatus !== "active") {
        toast.error(
          `Tu cuenta no esta completa. \n ${status !== "active" ? "Completa tu información" : membershipStatus !== "active" && "Contrata una membresia."}`
        );
        return;
      }
      setLoading(true);
      const routes = await getRoutesAPI(); //peticion a todas las rutas
      const routesAssigned = await getRoutesAssignedAPI(); // peticion a rutas asignadas

      dispatch(
        setListRoutesAssigned({ listRoutesAssigned: routesAssigned ?? [] })
      );
      const totalRoutes = [...routes, ...routesAssigned];
      const routesOfMembership = filterRoutesOfMembership(
        { paymentDate: lastPayment, expiresDateMembership: nextPayment },
        totalRoutes ?? []
      );
      // console.log("Rutas de la membresía:", routesOfMembership);

      dispatch(
        setlistRoutes({
          listRoutes: routes ?? [],
          totalOfRoutesMembership: routesOfMembership ?? 0,
        })
      );
      setLoading(false);
    } catch (error) {
      const { message } = handleError(error);
      setLoading(false);
      toast.error(
        `No se pudieron obtener tus rutas en este momento. \n ${message}`
      );
    }
  };

  return (
    <Box
      sx={{
        paddingLeft: 5,
        paddingRight: 5,
        display: "flex",
        flexDirection: "column",
        gap: 3,
      }}
    >
      <Loading loading={loading} />
      <ModalShareRoute
        open={showModalShare}
        selectedRoute={routeSelected}
        setLoading={setLoading}
        setOpen={setShowModalShare}
      />
      <ModalNextToTheApp
        open={showModalNextApp}
        onClose={() => setShowModalNextApp(false)}
      />
      <Box
        sx={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: 3,
        }}
      >
        <Box sx={{ display: "flex", gap: 5 }}>
          <Chip
            label="Mis rutas"
            variant={"filled"}
            style={
              selectedChip === "myRoutes"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => {
              setRouteSelected({});
              setSelectedChip("myRoutes");
            }}
          />
          <Chip
            label="Mis rutas públicas"
            style={
              selectedChip === "routesPublicOfUser"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => {
              setRouteSelected({});
              setSelectedChip("routesPublicOfUser");
            }}
          />
          <Chip
            label="Rutas asignadas"
            style={
              selectedChip === "asignedRoutes"
                ? {
                    backgroundColor: "#e7ef7d",
                    color: "black",
                  }
                : {}
            }
            onClick={() => {
              setRouteSelected({});
              setSelectedChip("asignedRoutes");
            }}
          />
        </Box>
        {selectedChip === "myRoutes" && (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <Box
              sx={{ width: "100%", display: "flex", justifyContent: "center" }}
            >
              <MetricsOfRoutes />
            </Box>
            <Box
              sx={{
                width: "100%",
                display: "flex",
                gap: 3,
                justifyContent: "center",
              }}
            >
              <button
                className="btn btn-secondary d-flex align-items-center gap-2"
                style={{ width: "150px" }}
                onClick={() => navigation("new-route")}
              >
                <LuMapPinPlus />
                Nueva ruta
              </button>

              <IoReload
                className="text-primary fs-4"
                onClick={() => refreshData()}
              />
            </Box>
          </Box>
        )}
      </Box>
      <Box>
        {selectedChip === "myRoutes" && (
          <TableRoutes
            rows={listRoutesDontPublics}
            setSelectedRoute={setRouteSelected}
          />
        )}
        {selectedChip === "routesPublicOfUser" && (
          <TableRoutes
            rows={listRoutesPublicsOfUser}
            setSelectedRoute={setRouteSelected}
          />
        )}
        {selectedChip === "asignedRoutes" && (
          <TableRoutes
            rows={listRoutesAssigned}
            setSelectedRoute={setRouteSelected}
          />
        )}
      </Box>
      <Box
        sx={{ width: "100%", display: "flex", justifyContent: "center" }}
        id="previewMap"
      >
        <Box
          sx={{
            backgroundColor: "rgba(128, 128, 128, 0.55)",
            paddingLeft: 10,
            paddingRight: 10,
            paddingTop: 2,
            paddingBottom: 2,
            borderRadius: 3,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography className="text-primary fs-2">
            {routeSelected?.nameRoute ?? "Seleccione una ruta"}
          </Typography>
          <Box sx={{ display: "flex", gap: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Distancia</Typography>
              </Box>
              <Typography>{formatDistance(routeSelected?.distance)}</Typography>
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <RouteIcon className="text-primary " />
                <Typography>Terreno</Typography>
              </Box>
              <Typography>
                {routeSelected?.terrainType ?? "Sin especificar"}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                }}
              >
                <MilitaryTechIcon className="text-primary " />
                <Typography>Estado</Typography>
              </Box>
              <Typography
                className={`${routeSelected?.status === "completa" ? "text-success" : "text-danger"}`}
              >
                {routeSelected?.status ?? "incompleta"}
              </Typography>
            </Box>
          </Box>
          {routeSelected?._id && selectedChip === "myRoutes" && (
            <Button
              startIcon={<ShareIcon />}
              variant="contained"
              sx={{ backgroundColor: "#e7ef7d" }}
              onClick={() => setShowModalShare(true)}
            >
              Compartir ruta
            </Button>
          )}
          {routeSelected?._id && selectedChip === "asignedRoutes" && (
            <Box>
              <Typography textAlign={"center"}>
                Esta ruta te la asigno el coach:{" "}
              </Typography>
              <Typography textAlign={"center"} color="#e7ef7d">
                {routeSelected?.assignedBy?.nickName ?? "Nombre del coach"}{" "}
                {/* {routeSelected?.assignedBy?.lastName ?? ""} */}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>

      <Box
        sx={{ height: 500, width: "100%", borderRadius: 5, overflow: "hidden" }}
      >
        <MapPreview
          coordinates={routeSelected?.coordinates ?? []}
          setLoading={setLoading}
        />
      </Box>
    </Box>
  );
};
export default CompleteRoutes;
